import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent } from "../app/navigation/landing/landing.component";
import { PageNotFoundComponent } from "../app/navigation/page-not-found/page-not-found.component";

// Professional Products
import { ProfServicesComponent } from "../app/prof-products/prof-services/prof-services.component";
import { AboutComponent } from "../app/prof-products/about/about.component";
import { ClientsComponent } from "../app/prof-products/clients/clients.component";
import { ContactComponent } from "../app/prof-products/contact/contact.component";
import { ProductsComponent } from "../app/prof-products/products/products.component";

// Hardware & Software

const routes: Routes = [
  { path: 'landing', component: LandingComponent },
  { path: 'about', component: AboutComponent },
  { path: 'clients', component: ClientsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'products', component: ProductsComponent },
  { path: 'prof-services', component: ProfServicesComponent },
  { path: '', redirectTo: '/about', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
